import React from "react";
import styles from "./MyBalanceHeader.module.scss";
import packageIcon from "../../../../../assets/images/packages/Package.svg";
import { BalanceInfoType } from "../../../../../interface/site.interface";
// import transportIcon from "../../../../../assets/images/packages/Transport.svg";

interface Typess {
  myBalance: BalanceInfoType;
}

const MyBalanceHeader: React.FC<Typess> = ({ myBalance }) => {
  return (
    <div className={styles.my_balance_header}>
      <div className={styles.my_balance_header_item}>
        <div className={styles.my_balance_icon_container}>
          <img src={packageIcon} alt="package" />
        </div>

        <div className={styles.my_balance_header_text_container}>
          <p className={styles.my_balance_header_title}>
            {myBalance.get_page.balance}
          </p>
          <p className={styles.my_balance_header_amount}>
            {myBalance.balance} USD
          </p>
        </div>
      </div>

      {/* <div className={styles.my_balance_header_item}>
        <div className={styles.my_balance_icon_container}>
          <img src={transportIcon} alt="package" />
        </div>

        <div className={styles.my_balance_header_text_container}>
          <p className={styles.my_balance_header_title}> Xidmət Balansım</p>
          <p className={styles.my_balance_header_amount}>0.00 TL</p>
        </div>
      </div> */}
    </div>
  );
};

export default MyBalanceHeader;
